import React from 'react';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import { CopyButton, PageState } from 'components';

interface SignSuccessProps {
  signature: string;
  onReset: () => void;
}

export const SignSuccess = ({ signature, onReset }: SignSuccessProps) => {
  const handleLeave = (e: React.MouseEvent) => {
    e.preventDefault();
    onReset();
  };

  return (
    <PageState
      className='py-0'
      icon={faCheck}
      iconClass='success'
      title='Message signed'
      description={
        <>
          <div className='text-secondary text-left'>Signature:</div>
          <div className='textarea-with-copy'>
            <textarea
              readOnly
              className='form-control cursor-text'
              rows={7}
              defaultValue={signature}
            />
            <CopyButton className='mt-2' text={signature} />
          </div>
        </>
      }
      action={
        <button
          data-testid='closeTransactionSuccessBtn'
          id='closeButton'
          className='btn btn-primary mb-3 mt-0'
          onClick={handleLeave}
        >
          Done
        </button>
      }
    />
  );
};
